<template>
  <div class="confirmation">
    <vue-headful title="Confirmation - Alabama.travel" description="Confirm your new account to plan your next trip to beautiful Alabama." url="https://alabama.travel/confirmation"/>
    <div class="container">
      <div class="d-flex flex-row justify-content-center">
        <div>
          <div class="email-verification">Email Verification</div>
          <div class="confirm-message">Thank you for signing up to Alabama Travel. We have sent a code to your email. Please confirm this code to continue.</div>
          <input @click="showConfirmationHelp" id="confirmationCode" type="text" v-model="confirmationCode" placeholder="Confirmation Code" class="input-container confirm-code" :aria-invalid="invalidCode" />
          <div class="help-error" aria-live="polite">
            <span :style="{display: confirmationHelp ? 'inline-block' : 'none'}">Please enter the confirmation from the email.</span>
            <span>{{this.confirmationMessage}}</span>
          </div>
          <button @click="confirm" :disabled="disabledLogin" class="confirm-btn"><div class="confirm-text">Confirm Account</div></button>
          <div @click="resendConfirmationCode" class="resend">Resend confirmation code</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Auth } from 'aws-amplify';

export default {
  name: 'confirmation',
  data() {
    return {
      username: '',
      confirmationCode: '',
      disabledLogin: false,
      confirmationMessage: '',
      confirmationHelp: false,
      append: false,
      invalidCode: false,
    };
  },
  methods: {
    async confirm() {
      try {
        this.validateInput();
        await Auth.confirmSignUp(
          this.$route.params.myEmail,
          this.confirmationCode,
        );
        this.$router.push({ name: 'login' },
          () => {
            setTimeout(() => {
              this.makeToast();
            });
          }, 1000);
      } catch (err) {
        if (err.message === 'AuthError: Confirmation code cannot be empty' || err.message === 'Confirmation code cannot be empty' || err.message === 'CodeMismatchException: Invalid verification code provided, please try again.' || err.message === 'Invalid verification code provided, please try again.') {
          this.confirmationMessage = 'That code appears to be invalid. Please double check it and try again.';
          this.invalidCode = true;
          this.disabledLogin = false;
        } else if (err.message === 'Username cannot be empty') {
          this.confirmationMessage = 'Please enter the confirmation from the email.';
          this.invalidCode = true;
          this.disabledLogin = false;
        } else {
          this.confirmationMessage = err.message;
          this.invalidCode = true;
          this.disabledLogin = false;
        }
      }
    },
    validateInput() {
      this.confirmationMessage = '';
      this.confirmationHelp = false;
      this.disabledLogin = true;
      if (this.confirmationCode === '') {
        this.confirmationMessage = 'Please enter the confirmation from the email.';
        this.disabledLogin = false;
      } else if (this.validFormat(this.confirmationCode) === false) {
        this.confirmationCode = '';
        this.confirmationMessage = 'That code appears to be invalid. Please double check it and try again.';
        this.disabledLogin = false;
      }
    },
    validFormat(confirmationCode) {
      const re = /(\d{6}|(\d{3}\s\d{3}))$/; // 6 digits or 3 digits + " " + 3 digits
      const result = re.test(confirmationCode);
      return result;
    },
    showConfirmationHelp() {
      this.confirmationMessage = '';
      this.confirmationHelp = true;
    },
    makeToast() {
      this.$bvToast.toast('Thanks for verifying your email.', {
        title: 'Success!',
        autoHideDelay: 3000,
        appendToast: this.append,
      });
    },
    async resendConfirmationCode() {
      try {
        Auth.resendSignUp(this.$route.params.myEmail); // Requires email address
        // Show success toast
        this.$bvToast.toast('A new verification code was resent successfully!', {
          title: 'Sent Successfully! Please check your email.',
          autoHideDelay: 3000,
          appendToast: this.append,
        });
      } catch (err) {
        // Show error toast
        this.$bvToast.toast('A new verification code was not sent!', {
          title: 'Sorry, there was an error.',
          autoHideDelay: 3000,
          appendToast: this.append,
        });
      }
    },
  },
};
</script>

 <style scoped>
   .confirmation {
    margin-top: 40px;
  }
  .email-verification {
    width: 245px;
    height: 60px;
    margin: 0 auto;
    font-family: IdealSans-Medium;
    font-size: 30px;
    font-weight: 900;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: 0.83px;
    text-align: center;
    color: #173945;
  }
  .confirm-message {
    width: 300px;
    height: 48px;
    margin: 21px auto 28px;
    font-family: IdealSans-Medium;
    font-size: 14px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.14;
    letter-spacing: 0.39px;
    text-align: center;
    color: #173945;
  }
  .input-container {
    width: 300px;
    height: 50px;
    padding: 18px 12px;
    border-radius: 8px;
    border: solid 1px #979797;
    background-color: #fff;
    color: black;
  }
  .input-container::placeholder {
    color: black;
    opacity: 1;
  }
  .confirm-code {
    font-family: IdealSans-Medium;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: 0.39px;
    color: #000;
  }
  .help-error {
    width: 300px;
    height: 12px;
    margin: 0 0 100px 25px;
    font-family: IdealSans-Medium;
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: 0.33px;
    text-align: left;
    color: #000;
  }
  .confirm-btn {
    width: 300px;
    height: 61px;
    padding: 18px 0 ;
    border-radius: 8px;
    border: solid 1px #979797;
    background-color: #173945;
    cursor: pointer;
  }
  .confirm-btn:focus {
    outline: 2.75px dotted !important;
    outline-color: #4c8ea0 !important;
    outline-offset: 3px !important;
  }
  .confirm-btn:hover {
    box-shadow: 0px 0px 3px #173945;
  }
  .confirm-text {
    width: 160px;
    height: 18px;
    font-family: IdealSans-Medium;
    font-size: 18px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: 0.5px;
    text-align: center;
    color: #f7f6f1;
    margin: 0 auto;
  }
  .resend {
    height: 14px;
    font-family: IdealSans-Medium;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: 0.39px;
    text-align: center;
    color: #a5b1b6;
    margin-top: 28px;
  }
  .resend:hover {
    text-decoration: underline;
  }
  input {
    margin: 0px 0 10px 0px;
    padding: 15px;
    min-width: 270px;
  }
  label {
    margin-bottom: 0px;
    font-size:14px;
    font-style: italic;
  }
  button, .resend {
    cursor: pointer;
  }
</style>
